__turbopack_context__.v({
  "sliderContainer": "SliderWithTicks-module-scss-module__7xsbaW__sliderContainer",
  "tick": "SliderWithTicks-module-scss-module__7xsbaW__tick",
  "ticksOverlay": "SliderWithTicks-module-scss-module__7xsbaW__ticksOverlay",
});
